import { BONUSX_SUBSCRIPTION_TIERS } from "../../services/user-subscription/enums/bonusx-subscription-tiers.enum";

export function getTranslationKeyForSubscriptionTier(tier: BONUSX_SUBSCRIPTION_TIERS): string {
  return `SUBSCRIPTION_TIER_${tier?.toUpperCase()}_NAME`;
}
